import { Tiptap } from '@/components/ui/tiptap-editor';
import { postExtensionSet } from '@/lib/tiptap-extensions-sets';

interface ParentRichTextProps {
  content: string;
}

/**
 * A teacher-authored description in a parent view: an assignment's or quiz's
 * own description, or the feedback left on a submission.
 *
 * All of them are written in the Tiptap editor and stored as HTML, so Tiptap has
 * to render them back — printed as text they show their raw markup. Read-only,
 * and toned down to secondary text because the editor's own paragraph styling is
 * sized for an editing surface rather than for reading.
 */
export function ParentRichText(parentRichTextProps: ParentRichTextProps) {
  const { content } = parentRichTextProps;

  return <Tiptap extensions={postExtensionSet} editable={false} content={content} className={'[&_p]:text-muted-foreground [&_p]:text-sm'} />;
}
